import api from '@/api'
import { createStore } from 'vuex'

// Modules
import cart from './modules/cart'
import auth from './modules/auth'
import user from './modules/user'
import modal from './modules/modal'
import payment from './modules/payment'
import summary from './modules/summary'
import country from './modules/country'
import vouchers from './modules/vouchers'
import eVouchers from './modules/eVouchers'
import settings from './modules/settings'
import checkout from './modules/checkout'
import product from './modules/product'
import formOptions from './modules/formOptions'
import translations from './modules/translations'
import invoiceAddress from './modules/invoiceAddress'
import deliveryAddress from './modules/deliveryAddress'

// Vuex plugin to inject api (replacement for Vuex.Store.prototype.api = api)
const apiPlugin = (store) => {
  store.api = api
}

const state = {}
const actions = {}
const mutations = {}
const getters = {}

export default createStore({
  state,
  mutations,
  actions,
  getters,
  modules: {
    cart,
    deliveryAddress,
    formOptions,
    invoiceAddress,
    modal,
    payment,
    summary,
    translations,
    vouchers,
    eVouchers,
    auth,
    user,
    checkout,
    product,
    settings,
    country,
  },
  plugins: [apiPlugin],
  strict: process.env.NODE_ENV !== 'production',
})
